<div class="d-flex min-vh-100 position-relative overflow-hidden">
  <!-- Animated Background -->
  <div
    class="bg-gradient position-absolute top-0 start-0 w-100 h-100"
    style="
      background: linear-gradient(
        -45deg,
        #1e3c72 0%,
        #2a5298 25%,
        #667eea 50%,
        #764ba2 75%,
        #f093fb 100%
      );
      background-size: 400% 400%;
      animation: gradientShift 15s ease infinite;
      z-index: -1;
    "
  ></div>

  <!-- Centered Login Card -->
  <div class="container d-flex justify-content-center align-items-center min-vh-100 w-100">
    <div class="w-100" style="max-width: 420px">
      <div
        class="card border-0 shadow-xl rounded-4 overflow-hidden"
        style="
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transform: translateY(-8px);
        "
      >
        <div class="card-body p-5">
          <div class="text-center mb-4">
            <img
              src="/logo.png"
              alt="NS Installazioni Logo"
              class="mb-3"
              style="max-width: 120px; height: auto"
            />
            <h2
              class="h3 fw-bold"
              style="color: #1e3c72; text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1)"
            >
              Accedi a NS Installazioni
            </h2>
            <p class="text-muted mb-0 fw-medium">Inserisci la tua email per effettuare l'accesso</p>
          </div>

          <form
            [formGroup]="loginForm"
            (ngSubmit)="sendMagicLink()"
            class="needs-validation"
            novalidate
          >
            <div class="mb-4">
              <label for="email" class="form-label fw-semibold mb-3" style="color: #1e3c72">
                <i class="fas fa-envelope me-2"></i>Email
              </label>
              <input
                type="email"
                id="email"
                formControlName="email"
                class="form-control form-control-lg rounded-3 shadow-sm"
                style="
                  border: 2px solid rgba(102, 126, 234, 0.2);
                  padding: 1rem 1.25rem;
                  transition: all 0.3s ease;
                  background: rgba(255, 255, 255, 0.9);
                "
                placeholder="Inserisci la tua email"
                required
              />

              @if (
                controls['email'].invalid && (controls['email'].dirty || controls['email'].touched)
              ) {
                <div
                  class="invalid-feedback d-block mt-3 p-3 bg-danger bg-opacity-10 border rounded-3 small"
                >
                  @if (controls['email'].hasError('required')) {
                    <div><i class="fas fa-exclamation-circle me-2"></i>Email obbligatoria.</div>
                  }
                  @if (controls['email'].hasError('pattern')) {
                    <div>
                      <i class="fas fa-exclamation-circle me-2"></i>Inserisci un indirizzo email
                      valido.
                    </div>
                  }
                </div>
              }
            </div>

            <button
              type="submit"
              class="btn btn-primary w-100 btn-lg fw-semibold rounded-3 shadow-lg px-5 py-3 border-0"
              style="
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                transform: translateY(-2px);
                box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
                transition: all 0.3s ease;
                border: none;
                font-size: 1.1rem;
              "
              [disabled]="loginForm.invalid || loading"
            >
              <i class="fas fa-paper-plane me-2" *ngIf="!loading"></i>
              <i class="fas fa-spinner fa-spin me-2" *ngIf="loading"></i>
              {{ loading ? 'Invio...' : 'Invia Magic Link' }}
            </button>
          </form>

          @if (message) {
            <div
              class="alert alert-info text-center mt-4 p-4 rounded-3 shadow-sm border-0"
              role="alert"
              style="background: rgba(102, 126, 234, 0.1); border-left: 4px solid #667eea"
            >
              <i class="fas fa-info-circle me-2"></i>
              {{ message }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  @keyframes gradientShift {
    0%,
    100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }

  /* Input focus effects */
  .form-control:focus {
    border-color: #667eea !important;
    box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25) !important;
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 1);
  }

  /* Button hover effects */
  .btn-primary:hover:not(:disabled) {
    transform: translateY(-4px) !important;
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.5) !important;
    background: linear-gradient(135deg, #5a6fd8 0%, #6a44a0 100%) !important;
  }

  .btn-primary:active:not(:disabled) {
    transform: translateY(-1px) !important;
  }

  .btn-primary:disabled {
    opacity: 0.7;
    transform: none;
    cursor: not-allowed;
  }

  /* Card hover effect */
  .card:hover {
    transform: translateY(-12px) !important;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2) !important;
  }

  /* Responsive adjustments */
  @media (max-width: 576px) {
    .card {
      margin: 1rem !important;
      transform: none !important;
    }

    .card-body {
      padding: 2rem 1.5rem !important;
    }
  }

  /* Smooth transitions */
  * {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.5);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(102, 126, 234, 0.7);
  }
</style>
